import { render, staticRenderFns } from "./DiscountCodeInFactorList.vue?vue&type=template&id=6a991e8d&scoped=true"
import script from "./DiscountCodeInFactorList.vue?vue&type=script&lang=js"
export * from "./DiscountCodeInFactorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a991e8d",
  null
  
)

export default component.exports